import gql from 'graphql-tag';

export default gql`
  fragment salesforceLeadFieldSelectOptionFragment on SalesforceLeadFieldSelectOption {
    id
    isActive
    isDefault
    label
    value
  }
`;
